/**
 * 與 scripts/lib/parking-ev-name-match.js 同一套場名規則（彈窗防舊關聯）。
 */

const CLOSE_GENERIC_M = 20;

export function normalizeParkingVenueName(raw) {
    return String(raw || '')
        .replace(/臺/g, '台')
        .replace(/\s+/g, '')
        .replace(/[（）()［］\[\]【】]/g, '')
        .replace(/交通局轄管|工務局轄管|轄管/g, '')
        .replace(/市立/g, '')
        .replace(/^(新北市|台北市|台中市|台南市|高雄市|桃園市|基隆市|新竹市|嘉義市|新北|台北|台中|台南|高雄|桃園)/, '')
        .replace(/^\d{2,4}停車聯盟[-－]?/, '')
        .replace(/停車聯盟[-－]?/, '');
}

export function venueCore(raw) {
    let s = normalizeParkingVenueName(raw);
    s = s
        .replace(/國民中學/g, '國中')
        .replace(/國民小學/g, '國小')
        .replace(/高級中學/g, '高中');
    let prev;
    do {
        prev = s;
        s = s
            .replace(/evbar$/i, '')
            .replace(/充電站$/g, '')
            .replace(/(地下|平面|立體|塔式)?停車場$/g, '')
            .replace(/共構$/g, '');
    } while (s !== prev);
    s = s.replace(/場$/g, '');
    return s;
}

export function isGenericStationName(name) {
    const c = venueCore(name);
    return !c || c.length < 3 || /^(充電|ev|tesla|supercharger)$/i.test(c);
}

export function parkingVenueNamesMatch(stationName, parkingName) {
    const ca = venueCore(stationName);
    const cb = venueCore(parkingName);
    if (!ca || !cb) return false;
    if (ca === cb) return true;
    const [shorter, longer] = ca.length <= cb.length ? [ca, cb] : [cb, ca];
    if (shorter.length < 3) return false;
    const at = longer.indexOf(shorter);
    if (at < 0) return false;
    const rest = longer.slice(at + shorter.length);
    return !rest || /^(地下|平面|立體|共構|充電)?$/.test(rest);
}

export function isOnSiteEvStation(station, parkingName) {
    const name = station?.name || '';
    const dist = Number(station?.dist_m);
    if (station?.name_match === true) return true;
    if (parkingVenueNamesMatch(name, parkingName)) return true;
    if (Number.isFinite(dist) && dist <= CLOSE_GENERIC_M && isGenericStationName(name)) return true;
    return false;
}

export function filterOnSiteEvStations(linked, parkingName) {
    return (Array.isArray(linked) ? linked : []).filter((s) => isOnSiteEvStation(s, parkingName));
}
